import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'

$(function () {
  $(".ny-banner .ny-nav a").on('click',function () {
    $("html, body").animate({
      scrollTop: $($(this).attr("href")).offset().top
    }, {duration: 500,easing: "swing"});
    return false;
  });
});